import { Wheat, Shrimp, Egg, Fish, Nut, Sprout, Milk, Bean, Carrot, Droplet, CircleDot, Wine, Flower, Shell } from "lucide-react";

// 14 alérgenos oficiales de la UE. La clave (en inglés) se guarda en la base de datos.
export const ALLERGENS = [
  { key: "Gluten", es: "Gluten", icon: Wheat, color: "#B45309" },
  { key: "Crustaceans", es: "Crustáceos", icon: Shrimp, color: "#E11D48" },
  { key: "Eggs", es: "Huevos", icon: Egg, color: "#CA8A04" },
  { key: "Fish", es: "Pescado", icon: Fish, color: "#0369A1" },
  { key: "Peanuts", es: "Cacahuetes", icon: Bean, color: "#92400E" },
  { key: "Soybeans", es: "Soja", icon: Sprout, color: "#15803D" },
  { key: "Milk", es: "Lácteos", icon: Milk, color: "#2563EB" },
  { key: "Nuts", es: "Frutos de cáscara", icon: Nut, color: "#7C2D12" },
  { key: "Celery", es: "Apio", icon: Carrot, color: "#16A34A" },
  { key: "Mustard", es: "Mostaza", icon: Droplet, color: "#D97706" },
  { key: "Sesame", es: "Sésamo", icon: CircleDot, color: "#A16207" },
  { key: "Sulphites", es: "Sulfitos", icon: Wine, color: "#9333EA" },
  { key: "Lupin", es: "Altramuces", icon: Flower, color: "#DB2777" },
  { key: "Molluscs", es: "Moluscos", icon: Shell, color: "#0891B2" },
];

export const ALLERGEN_MAP = Object.fromEntries(ALLERGENS.map((a) => [a.key, a]));

export const LANGUAGES = [
  { code: "es", native: "Español", name: "Spanish" },
  { code: "en", native: "English", name: "English" },
  { code: "fr", native: "Français", name: "French" },
  { code: "de", native: "Deutsch", name: "German" },
  { code: "it", native: "Italiano", name: "Italian" },
  { code: "pt", native: "Português", name: "Portuguese" },
  { code: "nl", native: "Nederlands", name: "Dutch" },
  { code: "sv", native: "Svenska", name: "Swedish" },
  { code: "pl", native: "Polski", name: "Polish" },
  { code: "ru", native: "Русский", name: "Russian" },
  { code: "zh", native: "中文", name: "Chinese" },
  { code: "ja", native: "日本語", name: "Japanese" },
  { code: "ar", native: "العربية", name: "Arabic" },
];
